import EsetleirasDto from 'app/admin/esetleiras/dto/EsetleirasDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class EsetleirasTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'esetleirasTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, EsetleirasDto)))
				.catch(reject);
		});
	}
}

export default new EsetleirasTableService();
